module.exports = __webpack_public_path__ + "static/progetto_cortefutura1-fd52636a08f8494b8f5608b5c2aec182.jpg";